import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const MODAL_OVERLAY_Z_INDEX = 9999;
const MODAL_CONTENT_Z_INDEX = 10001;

const Lightbox = ({ 
  isOpen, 
  currentImage, 
  currentIndex, 
  totalImages, 
  onClose, 
  onNext, 
  onPrevious 
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: MODAL_OVERLAY_Z_INDEX,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
      onClick={onClose}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255, 255, 255, 0.1)',
          border: 'none',
          color: 'white',
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'background 0.2s ease',
          zIndex: MODAL_CONTENT_Z_INDEX + 1
        }}
        onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
        onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
      >
        <X size={24} />
      </button>

      {/* Previous Button */}
      {totalImages > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrevious();
          }}
          style={{
            position: 'absolute',
            left: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: 'white',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background 0.2s ease',
            zIndex: MODAL_CONTENT_Z_INDEX + 1
          }}
          onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
        >
          <ChevronLeft size={24} />
        </button>
      )}

      {/* Image */}
      <img
        src={currentImage}
        alt={`Gallery ${currentIndex + 1}`}
        style={{
          maxWidth: '90%',
          maxHeight: '90vh',
          objectFit: 'contain',
          zIndex: MODAL_CONTENT_Z_INDEX
        }}
        onClick={(e) => e.stopPropagation()}
      />

      {/* Next Button */}
      {totalImages > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          style={{
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: 'white',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background 0.2s ease',
            zIndex: MODAL_CONTENT_Z_INDEX + 1
          }}
          onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
        >
          <ChevronRight size={24} />
        </button>
      )}

      {/* Counter */}
      {totalImages > 1 && (
        <div
          style={{
            position: 'absolute',
            bottom: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            fontSize: '14px',
            fontFamily: 'Raleway, sans-serif',
            background: 'rgba(0, 0, 0, 0.5)',
            padding: '8px 16px',
            borderRadius: '20px',
            zIndex: MODAL_CONTENT_Z_INDEX + 1
          }}
        >
          {currentIndex + 1} / {totalImages}
        </div>
      )}
    </div>
  );
};

export default Lightbox;
